import { render, staticRenderFns } from "./HornorBuyGuideProcessing.vue?vue&type=template&id=15668368&scoped=true&"
import script from "./HornorBuyGuideProcessing.vue?vue&type=script&lang=js&"
export * from "./HornorBuyGuideProcessing.vue?vue&type=script&lang=js&"
import style0 from "./HornorBuyGuideProcessing.vue?vue&type=style&index=0&id=15668368&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15668368",
  null
  
)

export default component.exports